import {UserPermission} from '@interface/user-permission';
import {UserRole} from '@enum/user-roles/user-role';
import {InterCompanyField} from '@enum/client/inter-company-field';
import {UserAreaFilter} from '@enum/user-area/user-area-filter';
import {OrderModalComponent} from '../../../components/order-modal/order-modal.component';
import {UserPermissionManager} from './user-permission';
import {ProformaLabels} from '../proforma-cart-labels/proforma-labels';
import {AllUserAreaColumns} from '@enum/user-area/user-area-column';
import {PartnerType} from '@enum/user-roles/partner-type';
import {CrmSection} from '@enum/crm-section';

class AgentPermissionClass implements UserPermission {
  readonly userRole = UserRole.SELLER;
  readonly labelRole = 'Agent';
  readonly isAuthenticated = true;

  readonly canRequestEto = true;
  readonly isDefaultUntaxedPrice = true;
  readonly canAlwaysGoToConfigurationSummary = false;

  readonly canModifyAllConfigurations = false;
  readonly canSeeConfigurationsPrice = true;

  readonly hasMoreClients = true;
  readonly canSeeHisAccountInRightDrawer = false;
  readonly canSeeHisAccountPreferences = false;
  readonly canHaveManyEditableProforma = true;
  readonly canModifyCountry = true;

  readonly canRegisterShopVendorFinalUser = false;
  readonly canSeeAlternativeExternalCustomersTab = false;
  readonly canSeeShopVendorList = false;
  readonly canChangeLogo = false;

  readonly canGoToUserArea = true;
  readonly crmSectionsVisible = [CrmSection.VerifiedContact, CrmSection.CustomerList, CrmSection.SalesTasks, CrmSection.Orders, CrmSection.Messages, CrmSection.Claims];
  readonly isLabelRoleVisibleInHeader = false;

  readonly proformaCartLabels = ProformaLabels;

  readonly visibleInterCompanyDependentFields = [InterCompanyField.AGENCY];
  readonly editableInterCompanyDependentFields = [];

  readonly visibleUserAreaFilters = [UserAreaFilter.USERID, UserAreaFilter.CUSTOMERCHANNEL, UserAreaFilter.INTERCOMPANY];
  readonly visibleUserAreaColumns = AllUserAreaColumns;

  readonly orderViewModal = OrderModalComponent;

  readonly canAssignCrmTaskToOthers = true;
  readonly canSeeAssignedUserStats = false;

  readonly canSelfAssignClaims = false;
  readonly canEditClaimAnswer = false;
  readonly canOpenNewClaims = true;
  readonly canHandleAdvancedClaimInfo = false;

  readonly canGiveExpirationFeedback = true;
  readonly canDownloadPackingList = true;
  readonly canSeeConfigurationList = true;
  readonly canSeeCustomerConfigurationTab = true;
  readonly canSeeSummaryRecap = false;
  readonly canEditProbability = true;

  readonly composerAllowed = true;
}

const AgentPermission = new AgentPermissionClass();

UserPermissionManager.instance.assignPermissionWithCheckingFn(
  AgentPermission,
  ({role, partnerType}) => role === AgentPermission.userRole && partnerType === PartnerType.Agent
);
